import { render, staticRenderFns } from "./twoIndex.vue?vue&type=template&id=0e47a7c6&scoped=true&"
import script from "./twoIndex.vue?vue&type=script&lang=ts&"
export * from "./twoIndex.vue?vue&type=script&lang=ts&"
import style0 from "./twoIndex.vue?vue&type=style&index=0&id=0e47a7c6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e47a7c6",
  null
  
)

export default component.exports